import React, { FormEvent, useEffect, useState } from "react";
import io from "socket.io-client";
import axios from "../axios";

const INVESTMENT_MIN_AMOUNT = 1000; // Minimum investment amount in USD
const INVESTMENT_MAX_AMOUNT = 100000; // Maximum investment amount in USD
const INVESTMENT_DURATION_WEEKS = 52; // Investment duration in weeks
const INVESTMENT_ANNUAL_RETURN_RATE = 0.15; // Annual return rate (15%)
const INVESTMENT_EARLY_WITHDRAWAL_PENALTY_RATE = 0.05; // Penalty rate for early withdrawal (5%)
// Define a function to calculate the investment return
// function calculateInvestmentReturn(amount) {
//     const annualReturn = amount * INVESTMENT_ANNUAL_RETURN_RATE;
//     const weeklyReturn = annualReturn / 52;
//     const totalReturn = weeklyReturn * INVESTMENT_DURATION_WEEKS;
//     return totalReturn;
//   }

// Define a function to process a new investment
// function processInvestment(userId, amount) {
//   if (amount < INVESTMENT_MIN_AMOUNT || amount > INVESTMENT_MAX_AMOUNT) {
//     throw new Error('Invalid investment amount');
//   }
//   // TODO: Process the investment and record it in the database
// }

// // Define a function to process an early withdrawal
// function processEarlyWithdrawal(userId, investmentId) {
//   // TODO: Check if the investment is eligible for early withdrawal
//   // and calculate the withdrawal amount after applying the penalty
//   // Process the withdrawal and update the database
// }

const InvestmentForm = ({ user }: any) => {
  const [apiResponse, setApiResponse] = useState<string | null>(null);

  const [amount, setAmount] = useState(0);

  const handleSubmit = async (
    event: React.SyntheticEvent,
    id: string,
    username: string
  ) => {
    event.preventDefault();
    let Amount: Number = Number(amount);
    try {
      const res = await axios.post("/invest/", {
        amount: Amount,
        id,
        username,
      });
      if (res.status === 201) {
        console.log(res)
        return res;
      }
      if (res.status === 210) return res;
    } catch (err: any) {
      return { status: 400, data: err.message };
    }
  };
  function handlechange(event: React.ChangeEvent<HTMLInputElement>) {
    let amount = Number(event.target.value);
    setAmount(amount);
  }

  return (
    <form onSubmit={(event) => handleSubmit(event, user._id, user.username)}>
      <label>
        Investment amount:
        <input type="number" value={amount} onChange={handlechange} />
      </label>
      <button type="submit">Invest</button>
    </form>
  );
};
export default InvestmentForm;
function InvestmentTable() {
  // TODO: Fetch and display the user's investments from the database
}

function InvestmentChart() {
  // TODO: Display a chart of the user's investment returns over time
}
